import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { NotificationTypes } from 'src/app/app.enums';
import { ImageCroppedResponse } from 'src/app/common/image-cropper/image-cropper.component';
import { ArtistProduct } from 'src/app/models/artistproduct.model';
import { ArtistProductsService } from 'src/app/Services/artistproducts.service';
import { AuthConfig, AuthService, ResponseObject } from 'src/app/Services/auth.service';
import { CloudinaryImageService } from 'src/app/Services/cloudinary-image.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-onboarding-artist-product',
    templateUrl: './onboarding-artist-product.component.html',
    standalone: false
})
export class OnboardingArtistProductComponent implements OnInit {
  @Output() onSave = new EventEmitter<ArtistProduct>();
  @ViewChild('additionalFileUploadCmp') additionalFileUploadCmp!: FileUpload;
  public selectedItem: ArtistProduct = new ArtistProduct();
  public selectedFile!: File;
  public selectedProductId!: string | null;
  public additionalFiles: any[] = [];
  public enableCropper: boolean = true;
  public currentSelectedImageToCrop?: File;
  public showCropperDialog: boolean = false;
  public authConfig: AuthConfig = {};
  public artistId!: string;
  public isAdditionalImage: boolean = false;
  constructor(
    private ngxSpinnerService: NgxSpinnerService,
    private notificationsService: NotificationsService,
    private uploadService: CloudinaryImageService,
    private artistProductsService: ArtistProductsService,
    private confirmationService: ConfirmationService,
    private authService: AuthService,
    private router: Router,
    private transloco: TranslocoService,
  ) { }
  ngOnInit() {
    this.authConfig = this.authService.getAuthConfig();
    this.artistId = this.authService.getUserId();
  }
  public removeImg(event: any): void {
    this.selectedItem.ProductImgUrl = '';
  }
  public onFileSelected(files: File[]): void {
    if (files.length > 0) {
      this.currentSelectedImageToCrop = files[0];
      const isImage: boolean = this.currentSelectedImageToCrop['type'].includes('image');
      if (isImage && this.enableCropper) {
        this.isAdditionalImage = false;
        this.showCropperDialog = true;
      }
    }
  }

  public onImageCropped($cropResponse: ImageCroppedResponse): void {
    this.isAdditionalImage = false;
    this.showCropperDialog = false;
    this.selectedFile = $cropResponse.CroppedImage;
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('ImageFile', this.selectedFile);
      this.ngxSpinnerService.show();
      this.uploadService.uploadImage(formData).subscribe(
        (imageUrl: string) => {
          if (this.selectedProductId) {
            if ($cropResponse.IsAdditionalImage) {
              this.ngxSpinnerService.show();
              this.artistProductsService.connectUploadedImages(this.artistId, this.selectedProductId, [imageUrl])
                .subscribe((response: ResponseObject) => {
                  if (response.Success) {
                    this.notificationsService.showNotification(this.transloco.translate('onboardingArtistProduct.success'), this.transloco.translate('onboardingArtistProduct.imageUploaded'), NotificationTypes.Success);
                  } else {
                    this.notificationsService.showNotification(this.transloco.translate('onboardingArtistProduct.error'), this.transloco.translate('onboardingArtistProduct.errorSavingData'), NotificationTypes.Error);
                  }
                  this.ngxSpinnerService.hide();
                }, error => {
                  console.error(error);
                  this.ngxSpinnerService.hide();
                });
            } else {
              this.artistProductsService.connectProductCoverImage(this.artistId, this.selectedProductId, imageUrl)
                .subscribe((response: ResponseObject) => {
                  if (response.Success) {
                    this.selectedItem.ProductImgUrl = imageUrl;
                    this.notificationsService.showNotification(this.transloco.translate('onboardingArtistProduct.success'), this.transloco.translate('onboardingArtistProduct.productCoverUploaded'), NotificationTypes.Success);
                  } else {
                    this.notificationsService.showNotification(this.transloco.translate('onboardingArtistProduct.error'), this.transloco.translate('onboardingArtistProduct.errorSavingData'), NotificationTypes.Error);
                  }
                  this.ngxSpinnerService.hide();
                }, error => {
                  console.error(error);
                  this.ngxSpinnerService.hide();
                });
            }
          } else {
            this.selectedItem.ProductImgUrl = imageUrl;
            this.ngxSpinnerService.hide();
          }
        },
        error => {
          console.error(error);
          this.ngxSpinnerService.hide();
        }
      );
    }
  }
  public onImageCropperClose($event: any): void {
    this.showCropperDialog = false;
    if ($event.skipCropping) {
      // Optionally handle skipped cropping
    }
  }

  public removeChosenFile(file: File): void {
    const index = this.additionalFiles.indexOf(file);
    if (index >= 0) {
      this.additionalFiles.splice(index, 1);
    }
  }
  public saveProduct(event: any): void {
    this.ngxSpinnerService.show();
    this.artistProductsService.saveArtistProduct(this.artistId, this.selectedItem)
      .subscribe(response => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.onSave.emit(this.selectedItem);
          const productId = response.ResponseData as string;
          if (productId) {
            this.artistProductsService.connectUploadedImages(this.artistId, productId, [this.selectedItem.ProductImgUrl!])
              .subscribe();
          }
          this.notificationsService.showNotification(this.transloco.translate('onboardingArtistProduct.success'), this.transloco.translate('onboardingArtistProduct.productDataSaved'), NotificationTypes.Success);
          this.router.navigate(['/artists', 'artworks']);

        } else {
          this.notificationsService.showNotification(this.transloco.translate('onboardingArtistProduct.error'), response.ResponseMessage, NotificationTypes.Error);
        }
      }, error => {
        console.error(error);
        this.ngxSpinnerService.hide();
      });
  }
  public Exit(event: any): void {
    this.onSave.emit(this.selectedItem);
    this.router.navigate(['/dashboard']);

  }
}


